module.exports = __webpack_public_path__ + "media/img/user5-128x128-a1086465.jpg";